module.exports = __webpack_public_path__ + "static/media/Question_icon_2_white.e48fa54e.svg";